import settingsKeyPrefix from "./settings-key";

const debug = {
    dev: false,
    head: "{LocalSettings}"
};

// Seems like this is deprecated
// use LocalSettingsProtov4 ?

export default class LocalSettings {

    public storageKey: string
    public default : any

    constructor(key:string,defaultValues:any) {
        if (debug.dev) console.log(debug.head,"constuctor",key,defaultValues);
        this.storageKey = settingsKeyPrefix() + key;
        this.default = defaultValues;
    }

    loadFromJSON(data:any) {
        _.mapKeys(data, (value,key) => {
            this.set(key,value);
        });
    }

    set(name:string,value:any) {
        if (debug.dev) console.log("@Local settings SET ",name,"=",value);

        if (this.default[name]!==undefined) {
            const varName = this.storageKey+"."+name;

            value = this.serialize(value);

            try {
                localStorage.setItem(varName, value);
            } catch (err) {
                window.gdEpicFail("local-settings-not-available",err);
            }
        } else {
            if (debug.dev) console.error("LOCALSETTINGS class error - param ",name," not fount in default vars");
        }

    }

    setArr(name:string,value:any) {
        value = value.join();
        this.set(name,value);
    }

    get(name:string) {
        const varName = this.storageKey+"."+name;
        let value;
        try {
            value = localStorage.getItem(varName);
        } catch(err) {
            value = null;
            // @ts-ignore
            gdEpicFail('local-settings-not-available',err);
        }


        if (value==null) {
            //allow null as value ...
            if (this.default[name]!=null) {
                this.set(name,this.default[name]);
                return this.default[name];
            }
            else {
                return null;
            }

        } else {
            return value;
        }
    }

    getArr(name:string) {

        const val = this.get(name);

        if (val && typeof val == 'string') {
            return val.split(",");
        } else if (val && Array.isArray(val)) {
            return val;
        } else {
            return [];
        }
    }

    serialize(value:any) {

        // if (typeof value == ...)

        return value;
    }

    resetToDefault(name:string) {
        if (this.default[name]!=undefined) {
            const varName = this.storageKey+"."+name;
            localStorage.setItem(varName, this.default[name]);
        } else {
            if (debug.dev) console.error("LOCALSETTINGS class error - param ",name," not fount in default vars");
        }

    };

    toObject() {
        const res = {};
        _.mapKeys(this.default, (value,key)=>{
            // @ts-ignore
            res[key] = this.get(key)
        });
        return res;
    }

}

// module.exports = LocalSettings;
